// src/components/ArticlesEditor.jsx
import React from "react";
import UploadField from "./UploadField";

export default function ArticlesEditor({ articles, setArticles }) {
  const add = () =>
    setArticles((arr) => [
      ...arr,
      { title: "", qty: 1, weight: "", value: "", images: [] },
    ]);

  const update = (i, patch) =>
    setArticles((arr) => arr.map((it, idx) => (idx === i ? { ...it, ...patch } : it)));

  const remove = (i) => setArticles((arr) => arr.filter((_, idx) => idx !== i));

  return (
    <div className="border rounded p-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="m-0">Articles</h6>
        <button className="btn btn-sm btn-outline-primary" type="button" onClick={add}>
          + Ajouter
        </button>
      </div>

      {articles.map((it, i) => (
        <div className="row g-2 align-items-end mb-3" key={i}>
          <div className="col-md-4">
            <label className="form-label">Désignation</label>
            <input
              className="form-control"
              value={it.title}
              onChange={(e) => update(i, { title: e.target.value })}
              placeholder="Ex: Téléphone, vêtements…"
            />
          </div>

          <div className="col-4 col-md-2">
            <label className="form-label">Qté</label>
            <input
              type="number"
              min={1}
              className="form-control"
              value={it.qty}
              onChange={(e) => update(i, { qty: Math.max(1, Number(e.target.value || 1)) })}
            />
          </div>

          <div className="col-4 col-md-2">
            <label className="form-label">Poids (kg)</label>
            <input
              className="form-control"
              value={it.weight}
              onChange={(e) => update(i, { weight: e.target.value })}
            />
          </div>

          <div className="col-4 col-md-2">
            <label className="form-label">Valeur (XOF)</label>
            <input
              className="form-control"
              value={it.value}
              onChange={(e) => update(i, { value: e.target.value })}
            />
          </div>

          <div className="col-md-2">
            <label className="form-label">Images</label>
            <UploadField
              pathPrefix="colis/articles"
              onUploaded={(url) => update(i, { images: [...(it.images || []), url] })}
            />
          </div>

          <div className="col-12">
            {(it.images || []).length > 0 && (
              <div className="d-flex flex-wrap gap-2 mt-2">
                {it.images.map((u, idx) => (
                  <div key={idx} className="position-relative">
                    <img
                      src={u}
                      alt="article"
                      style={{ width: 88, height: 88, objectFit: "cover" }}
                      className="rounded border"
                    />
                    <button
                      type="button"
                      className="btn btn-sm btn-light position-absolute top-0 end-0"
                      onClick={() =>
                        update(i, { images: it.images.filter((_, k) => k !== idx) })
                      }
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="col-12">
            <hr className="my-2" />
          </div>

          <div className="col-12 text-end">
            <button
              className="btn btn-sm btn-outline-danger"
              type="button"
              onClick={() => remove(i)}
            >
              Supprimer l'article
            </button>
          </div>
        </div>
      ))}

      {articles.length === 0 && (
        <div className="text-muted">Aucun article. Clique sur « Ajouter ».</div>
      )}
    </div>
  );
}
